import { styled } from '@mui/material/styles';
import { TableCell } from '@mui/material';

export const TableCellRight = styled(TableCell)({ textAlign: 'right' });
